import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TransactionFacade } from '@symphony-solo/domain/transaction/src';
import { Subscription } from 'rxjs';

@Component({
  selector: 'symphony-solo-basket-section',
  templateUrl: './basket-section.component.html',
  styleUrls: ['./basket-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketSectionComponent implements OnInit, OnDestroy {
  public productName: string;
  public productPrice: number;
  public noOfProducts: number;
  public totalPrice: string;
  public isBasketEmpty = true;
  public totalTax$ = this.transactionFacade.totalTax$;
  public totalPrice$ = this.transactionFacade.totalPrice$;
  private lastProductAddedSubscription: Subscription;

  constructor(private transactionFacade: TransactionFacade) {}

  public ngOnInit(): void {
    this.subscribeToLastProductAdded();
  }

  public ngOnDestroy(): void {
    this.lastProductAddedSubscription.unsubscribe();
  }

  private subscribeToLastProductAdded(): void {
    this.lastProductAddedSubscription = this.transactionFacade.lastAddedProduct$.subscribe((product) => {
      this.isBasketEmpty = product ? false : true;
      this.productName = product ? product.name : 'Scan a product';
      this.productPrice = product ? product.price.value : null;
    });
  }
}
